// React
import { useEffect, useState } from 'react';
// Pages
import { Home, NewOrder, NewProduct, Order } from "@pages/";
// Router
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// Components
import { Banner } from "@components/";
// Services
import { initializeZafClient, popupError } from "./services/Zendesk";
// Contexts
import { SideConversationProvider } from "./contexts/SideConversationContext";

function App() {
  const [initialized, setInitialized] = useState(false);
  const [initError, setInitError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        await initializeZafClient();
        setInitialized(true);
      } catch (err) {
        console.error('❌ Erro ao inicializar Zendesk client:', err);
        const errorMessage = err instanceof Error ? err.message : 'Erro desconhecido';
        setInitError(errorMessage);
        popupError(`Erro ao inicializar aplicação: ${errorMessage}`, false);
      }
    })();
  }, []);

  if (initError) {
    return (
      <div className="flex items-center justify-center min-h-screen px-4">
        <div className="w-full max-w-lg text-center">
          <div className="p-6 bg-red-50 border border-red-200 rounded-lg">
            <h2 className="text-lg font-semibold text-red-800 mb-2">
              Erro na Inicialização
            </h2>
            <p className="text-red-600 mb-4">{initError}</p>
            <button 
              onClick={() => window.location.reload()} 
              className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
            >
              Tentar Novamente
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (!initialized) {
    return (
      <div className="flex items-center justify-center min-h-screen px-4">
        <div className="w-full max-w-lg text-center">
          <div className="p-6">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <h2 className="text-lg font-semibold text-gray-800 mb-2">
              Carregando...
            </h2>
            <p className="text-gray-600">Iniciando app Zendesk...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <SideConversationProvider>
      <Router>
        <div className="min-h-screen">
          <Banner />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/new-order" element={<NewOrder />} />
            <Route path="/order/:sideConversationId" element={<Order />} />
            <Route path="/new-product" element={<NewProduct />} />
          </Routes>
        </div>
      </Router>
    </SideConversationProvider>
  );
}

export default App;
